import CopyButton from './CopyButton';

export { ButtonType } from './types';
export default CopyButton;